/* wizardIndicator.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 28.1 28.1" preserveAspectRatio="none">
            <polygon class="foreground-gl" points="6.9,16.9 6.4,16 6,16.9 5,17.1 5.7,17.8 5.6,18.7 6.5,18.2 7.3,18.7 7.1,17.7 7.8,17 	"/>
            <polygon class="foreground-gl" points="9.5,13.7 10.3,13.2 9.4,12.8 9.1,11.9 8.5,12.6 7.5,12.6 8.1,13.4 7.7,14.3 8.7,14.1 9.5,14.7 	"/>
            <polygon class="foreground-gl" points="12.4,17.2 12.8,15.8 11.5,16.3 10.2,15.5 10.3,17 9.1,17.9 10.6,18.2 11.1,19.6 11.9,18.4 13.3,18.4 "/>
            <polygon class="foreground-gl" points="5.7,13.1 6.5,11.9 5.1,12 4.1,10.8 3.8,12.3 2.4,12.8 3.7,13.6 3.7,15 4.8,14.1 6.3,14.5 	"/>
            <polygon class="foreground-gl" points="7.8,10.1 9.4,8.8 11.5,9.4 10.7,7.4 12,5.6 9.8,5.7 8.6,4 8,6.1 5.9,6.8 7.7,7.9 	"/>
            <polygon class="foreground-gl" points="3.3,8.4 5,7.9 3.6,6.9 3.7,5.1 2.3,6.1 0.7,5.4 1.2,7.1 0,8.4 1.8,8.5 2.7,10 	"/>
            <path class="foreground-gl" d="M28.1,5.7C28,5.3,27.9,5,27.6,4.8l-0.3-0.3c-0.3-0.2-0.7-0.3-1-0.3c-0.4,0.1-0.7,0.2-0.9,0.5L12.8,21.6
                c-0.5,0.6-0.3,1.5,0.3,2l0.3,0.2c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.1,0,0.2,0c0.4-0.1,0.7-0.2,0.9-0.5L27.9,6.9
                C28.1,6.4,28.2,6,28.1,5.7z M14.8,23.1c-0.1,0.2-0.3,0.3-0.5,0.3s-0.4,0-0.6-0.2L13.4,23c-0.4-0.3-0.4-0.8-0.2-1.2l2.8-3.7l1.6,1.2
                L14.8,23.1z"/>
        </svg>
        `
};